import { Container, styled } from "@mui/material";
import { OneTimePassword } from "./one-time-password";
import { MagicLink } from "./magic-link";
import { Error } from "./error";
import { LoginProvider } from "./context";
import { SelectAccount } from "./select-account";
import { useAppContext } from "../Header/context";

export const Login = () => {
  const { usage } = useAppContext();

  if(usage === "PARENTALCONSENT") {
    return  <LoginContainer style={{maxWidth: "1024px"}}>
                If you have received an email, please follow the link in your email.
                <br/>
                This page doesn't have any content.
            </LoginContainer>
  }

  return (
    <LoginProvider>
      <LoginContainer style={{maxWidth: "1024px"}}>
            <MagicLink />
            <OneTimePassword />
            <SelectAccount />
            <Error />
      </LoginContainer>
    </LoginProvider>
  );
};

export const LoginContainer = styled(Container)({
  marginTop: "24px"
});
